export default function (ModalService) {
    return function (vehicleId, keeperId) {
        return ModalService.showModal({
            controller: require('../../controllers/keepers/details/keeperDetailsCtrl'),
            template: require('../../controllers/keepers/details/keeper-details.html'),
            controllerAs: 'keeper',
            inputs: {
                vehicleId,
                keeperId
            }
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/keepers/openKeeperModal.js